import createModel, { prop } from './lib/create_model';

export const TeamAssistCannedResponse = createModel({
  modelName: 'TeamAssistCannedResponse',

  properties: {
    label: prop(String),
    message: prop(String),
    alwaysShow: prop(Boolean).default(false),
  },
});

export default createModel({
  modelName: 'TeamAssistConfiguration',

  properties: {
    cannedResponses: prop([TeamAssistCannedResponse]).default([]),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});
